export default function FirstIfNotEmpty<T>(input: T[] | null | undefined): T | null {
    if (input === null || input === undefined) return null;

    if (input.length > 0) {
        return input[0];
    } else {
        return null;
    }
}
